import { Record as record } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { construct, fields } from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    pan: null,
    cardType: null,
    cardHolderName: null,
    expiryDate: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    underReview: null,
    transactionReference: null,
    customerReference: null,
    billingId: null,
    created: null,
    refunded: null,
    latest: null,
    cardArtUrl: null
};


export default class CardPayment extends record(defaults) {

    static fromJSON (json = {}) {

        return construct(CardPayment, json, {
            id: fields.number,
            pan: fields.string,
            cardType: fields.string,
            cardHolderName: fields.string,
            expiryDate: fields.string,
            amount: fields.number,
            originalAmount: fields.number,
            amountRefunded: fields.number,
            underReview: fields.boolean,
            transactionReference: fields.string,
            customerReference: fields.string,
            billingId: fields.number,
            created: fields.datetime,
            refunded: fields.boolean,
            latest: fields.boolean,
            cardArtUrl: fields.string
        });

    }

    hasExpired () {
        const expiryDate = trainTime(this.expiryDate, 'MM/YYYY').endOf('month');
        return trainTime().isAfter(expiryDate);
    }

    hasAmount () {
        return this.amount > 0;
    }

    isRefundable () {
        return this.hasAmount();
    }

    hasLatestPayment () {
        return this.latest;
    }

    getPaymentAmount () {
        return this.amount;
    }

}
